import { defineMessages } from "react-intl";

export const settingsMessages = defineMessages({
  "settings.heading": { id: "settings.heading", defaultMessage: "Settings" },
  "settings.tabs.profile.label": {
    id: "settings.tabs.profile.label",
    defaultMessage: "Profile",
  },
  "settings.tabs.general.label": {
    id: "settings.tabs.general.label",
    defaultMessage: "General",
  },
  "settings.tabs.credits.label": {
    id: "settings.tabs.credits.label",
    defaultMessage: "Credits",
  },
  "settings.tabs.availability.label": {
    id: "settings.tabs.availability.label",
    defaultMessage: "Availability",
  },
  "settings.tabs.admin.label": {
    id: "settings.tabs.admin.label",
    defaultMessage: "Admin",
  },
  "settings.profile.aside.title": {
    id: "settings.profile.aside.title",
    defaultMessage: "Your coach profile preview",
  },
  "settings.profile.aside.save": {
    id: "settings.profile.aside.save",
    defaultMessage: "Save",
  },
  "settings.profile.heading": {
    id: "settings.profile.heading",
    defaultMessage: "Personal info",
  },
  "settings.profile.perex": {
    id: "settings.profile.perex",
    defaultMessage: "Update your info here",
  },
  "settings.profile.field.name": {
    id: "settings.profile.field.name",
    defaultMessage: "Name",
  },
  "settings.profile.field.email": {
    id: "settings.profile.field.email",
    defaultMessage: "Email",
  },
  "settings.profile.field.photo": {
    id: "settings.profile.field.photo",
    defaultMessage: "Photo",
  },
  "settings.profile.field.photo.limit": {
    id: "settings.profile.field.photo.limit",
    defaultMessage: "SVG, PNG, JPG or GIF (max. {maxSize})",
  },
  "settings.profile.field.bio": {
    id: "settings.profile.field.bio",
    defaultMessage: "Bio",
  },
  "settings.profile.field.webLink": {
    id: "settings.profile.field.webLink",
    defaultMessage: "Video introduction",
  },
  "settings.profile.field.webLink.placeholder": {
    id: "settings.profile.field.webLink.placeholder",
    defaultMessage: "https://",
  },
  "settings.profile.field.linkedinProfile": {
    id: "settings.profile.field.linkedinProfile",
    defaultMessage: "Linkedin Profile",
  },
  "settings.profile.field.linkedinProfile.placeholder": {
    id: "settings.profile.field.linkedinProfile.placeholder",
    defaultMessage: "https://",
  },
  "settings.profile.field.timezone": {
    id: "settings.profile.field.timezone",
    defaultMessage: "Timezone",
  },
  "settings.profile.field.languages": {
    id: "settings.profile.field.languages",
    defaultMessage: "Languages",
  },
  "settings.profile.field.languages.placeholder": {
    id: "settings.profile.field.languages.placeholder",
    defaultMessage: "Select languages you speak",
  },
  "settings.profile.field.fields": {
    id: "settings.profile.field.fields",
    defaultMessage: "Fields",
  },
  "settings.profile.field.fields.placeholder": {
    id: "settings.profile.field.fields.placeholder",
    defaultMessage: "Select fields you work in",
  },
  "settings.profile.field.certificates": {
    id: "settings.profile.field.certificates",
    defaultMessage: "Certificates",
  },
  "settings.profile.field.certificates.placeholder": {
    id: "settings.profile.field.certificates.placeholder",
    defaultMessage: "Enter certificate",
  },
  "settings.profile.field.experience": {
    id: "settings.profile.field.experience",
    defaultMessage: "Experience",
  },
  "settings.profile.field.level": {
    id: "settings.profile.field.level",
    defaultMessage: "Level",
  },
  "settings.profile.field.rate": {
    id: "settings.profile.field.rate",
    defaultMessage: "Rate",
  },
  "settings.profile.field.publicProfile": {
    id: "settings.profile.field.publicProfile",
    defaultMessage: "Public account",
  },
  "settings.profile.expertise": {
    id: "settings.profile.expertise",
    defaultMessage: "Expertise",
  },
  "settings.profile.field.primaryRoles": {
    id: "settings.profile.field.primaryRoles",
    defaultMessage: "Primary roles",
  },
  "settings.profile.field.primaryRoles.option.coach": {
    id: "settings.profile.field.primaryRoles.option.coach",
    defaultMessage: "Coach",
  },
  "settings.profile.field.primaryRoles.option.mentor": {
    id: "settings.profile.field.primaryRoles.option.mentor",
    defaultMessage: "Mentor",
  },
  "settings.profile.field.primaryRoles.option.trainer": {
    id: "settings.profile.field.primaryRoles.option.trainer",
    defaultMessage: "Trainer",
  },
  "settings.profile.field.primaryRoles.option.facilitator": {
    id: "settings.profile.field.primaryRoles.option.facilitator",
    defaultMessage: "Facilitator",
  },
  "settings.profile.field.primaryRoles.option.consultant": {
    id: "settings.profile.field.primaryRoles.option.consultant",
    defaultMessage: "Consultant",
  },
  "settings.profile.field.primaryRoles.option.speaker": {
    id: "settings.profile.field.primaryRoles.option.speaker",
    defaultMessage: "Speaker",
  },
  "settings.profile.field.baseLocations": {
    id: "settings.profile.field.baseLocations",
    defaultMessage: "Base Locations",
  },
  "settings.profile.field.baseLocations.placeholder": {
    id: "settings.profile.field.baseLocations.placeholder",
    defaultMessage: "Enter the city or region where you operate",
  },
  "settings.profile.field.travelWillingness": {
    id: "settings.profile.field.travelWillingness",
    defaultMessage: "Willing to Travel",
  },
  "settings.profile.field.deliveryFormat": {
    id: "settings.profile.field.deliveryFormat",
    defaultMessage: "Delivery Formats",
  },
  "settings.profile.field.serviceType": {
    id: "settings.profile.field.serviceType",
    defaultMessage: "Services Types",
  },
  "settings.profile.field.diagnosticTools": {
    id: "settings.profile.field.diagnosticTools",
    defaultMessage: "Diagnostic Tools Used",
  },
  "settings.profile.field.industryExperience": {
    id: "settings.profile.field.industryExperience",
    defaultMessage: "Relevant Industry Experience",
  },
  "settings.profile.field.references": {
    id: "settings.profile.field.references",
    defaultMessage: "References",
  },
  "settings.profile.field.references.placeholder": {
    id: "settings.profile.field.references.placeholder",
    defaultMessage:
      "Briefly describe a client case or engagement you’re proud of (no confidential details).",
  },

  "settings.user-profile.heading": {
    id: "settings.user-profile.heading",
    defaultMessage: "Profile",
  },
  "settings.user-profile.perex": {
    id: "settings.user-profile.perex",
    defaultMessage: "Update your profile here",
  },
  "settings.user-profile.field.name": {
    id: "settings.user-profile.field.name",
    defaultMessage: "Name",
  },
  "settings.user-profile.field.email": {
    id: "settings.user-profile.field.email",
    defaultMessage: "Email",
  },
  "settings.user-profile.field.company": {
    id: "settings.user-profile.field.company",
    defaultMessage: "Company",
  },
  "settings.user-profile.field.businessStrategy": {
    id: "settings.user-profile.field.businessStrategy",
    defaultMessage: "Company business strategy",
  },
  "settings.user-profile.field.manager": {
    id: "settings.user-profile.field.manager",
    defaultMessage: "Manager",
  },
  "settings.user-profile.field.position": {
    id: "settings.user-profile.field.position",
    defaultMessage: "Position",
  },
  "settings.user-profile.field.aspiredCompetency": {
    id: "settings.user-profile.field.aspiredCompetency",
    defaultMessage: "Aspired Competency",
  },
  "settings.user-profile.field.aspiredPosition": {
    id: "settings.user-profile.field.aspiredPosition",
    defaultMessage: "Aspired Position (2-5 Years)",
  },

  "settings.user-profile.field.firstName.placeholder": {
    id: "settings.user-profile.field.firstName.placeholder",
    defaultMessage: "Enter your first name",
  },
  "settings.user-profile.field.lastName.placeholder": {
    id: "settings.user-profile.field.lastName.placeholder",
    defaultMessage: "Enter your last name",
  },
  "settings.user-profile.field.username.placeholder": {
    id: "settings.user-profile.field.username.placeholder",
    defaultMessage: " ",
  },
  "settings.user-profile.field.company.placeholder": {
    id: "settings.user-profile.field.company.placeholder",
    defaultMessage: " ",
  },
  "settings.user-profile.field.businessStrategy.placeholder": {
    id: "settings.user-profile.field.businessStrategy.placeholder",
    defaultMessage: " ",
  },
  "settings.user-profile.field.manager.placeholder": {
    id: "settings.user-profile.field.manager.placeholder",
    defaultMessage: "Enter your manager",
  },
  "settings.user-profile.field.position.placeholder": {
    id: "settings.user-profile.field.position.placeholder",
    defaultMessage: "Enter your position",
  },
  "settings.user-profile.field.aspiredCompetency.placeholder": {
    id: "settings.user-profile.field.aspiredCompetency.placeholder",
    defaultMessage: "Enter your aspired competency",
  },
  "settings.user-profile.field.aspiredPosition.placeholder": {
    id: "settings.user-profile.field.aspiredPosition.placeholder",
    defaultMessage: "Enter your aspired position",
  },

  "settings.user-profile.save": {
    id: "settings.user-profile.save",
    defaultMessage: "Save",
  },

  "settings.general.heading": {
    id: "settings.general.heading",
    defaultMessage: "General",
  },
  "settings.general.perex": {
    id: "settings.general.perex",
    defaultMessage: "Update general app settings here",
  },
  "settings.general.field.language": {
    id: "settings.general.field.language",
    defaultMessage: "Language",
  },
  "settings.general.field.currentPassword": {
    id: "settings.general.field.currentPassword",
    defaultMessage: "Current password",
  },
  "settings.general.field.newPassword": {
    id: "settings.general.field.newPassword",
    defaultMessage: "New password",
  },
  "settings.general.field.newPasswordConfirm": {
    id: "settings.general.field.newPasswordConfirm",
    defaultMessage: "Confirm new password",
  },
  "settings.general.field.newPasswordConfirm.error-match": {
    id: "settings.general.field.newPasswordConfirm.error-match",
    defaultMessage: "Password confirm must match",
  },
  "settings.general.password": {
    id: "settings.general.password",
    defaultMessage: "Password",
  },
  "settings.general.button.cancel": {
    id: "settings.general.button.cancel",
    defaultMessage: "Cancel",
  },
  "settings.general.button.save": {
    id: "settings.general.button.save",
    defaultMessage: "Update password",
  },
  "settings.integrations": {
    id: "settings.integrations",
    defaultMessage: "Integrations",
  },
  "settings.integrations.google-calendar.title": {
    id: "settings.integrations.google-calendar.title",
    defaultMessage: "Want to sync your availability with Google Calendar?",
  },
  "settings.integrations.google-calendar.description": {
    id: "settings.integrations.google-calendar.description",
    defaultMessage:
      "Click Connect to automatically reflect your free/busy time from your Google Calendar.",
  },
  "settings.integrations.calendly.title": {
    id: "settings.integrations.calendly.title",
    defaultMessage: "Calendly",
  },
  "settings.integrations.calendly.description": {
    id: "settings.integrations.calendly.description",
    defaultMessage: "Sync your appointments with Calendly",
  },
  "settings.integrations.connect": {
    id: "settings.integrations.connect",
    defaultMessage: "Connect",
  },
  "settings.integrations.custom.title": {
    id: "settings.integrations.custom.title",
    defaultMessage: "Set your availability for TopLeader sessions",
  },
  "settings.integrations.custom.description": {
    id: "settings.integrations.custom.description",
    defaultMessage:
      "To appear as available to TopLeader users, you must define at least some time slots here.",
  },
  "settings.integrations.override-warning": {
    id: "settings.integrations.override-warning",
    defaultMessage:
      "It will override your {availabilitySource} availability hours",
  },
  "settings.integrations.reconnect": {
    id: "settings.integrations.reconnect",
    defaultMessage: "Reconnect",
  },
  "settings.integrations.connected": {
    id: "settings.integrations.connected",
    defaultMessage: "Connected",
  },
  "settings.integrations.disconnect": {
    id: "settings.integrations.disconnect",
    defaultMessage: "Disconnect",
  },
  "settings.availability.aside.title": {
    id: "settings.availability.aside.title",
    defaultMessage: "Preview",
  },
  "settings.availability.aside.save": {
    id: "settings.availability.aside.save",
    defaultMessage: "Save",
  },
  "settings.availability.heading": {
    id: "settings.availability.heading",
    defaultMessage: "Availability",
  },
  "settings.availability.perex": {
    id: "settings.availability.perex",
    defaultMessage:
      "Choose one of the integrations or set your custom availability hours",
  },
  "settings.availability.set-availability": {
    id: "settings.availability.set-availability",
    defaultMessage: "Set availability",
  },
  "settings.availability.recurring": {
    id: "settings.availability.recurring",
    defaultMessage: "Recurring",
  },
  "settings.availability.unavailable": {
    id: "settings.availability.unavailable",
    defaultMessage: "Unavailable",
  },
  "settings.admin.title": {
    id: "settings.admin.title",
    defaultMessage: "Users",
  },
  "settings.admin.title.count.badge": {
    id: "settings.admin.title.count.badge",
    defaultMessage: "{count} Users",
  },
  "settings.admin.sub": {
    id: "settings.admin.sub",
    defaultMessage: "Here you can see the list of your current clients",
  },
  "settings.admin.add": {
    id: "settings.admin.add",
    defaultMessage: "Add member",
  },
  "settings.admin.table.col.name": {
    id: "settings.admin.table.col.name",
    defaultMessage: "Name",
  },
  "settings.admin.table.col.companyName": {
    id: "settings.admin.table.col.companyName",
    defaultMessage: "Company",
  },
  "settings.admin.table.col.role": {
    id: "settings.admin.table.col.role",
    defaultMessage: "Role",
  },
  "settings.admin.table.col.primaryRoles": {
    id: "settings.admin.table.col.primaryRoles",
    defaultMessage: "Primary Roles",
  },
  "settings.admin.table.col.coach": {
    id: "settings.admin.table.col.coach",
    defaultMessage: "Current Coach",
  },

  "settings.admin.table.col.hrs": {
    id: "settings.admin.table.col.hrs",
    defaultMessage: "HR",
  },
  "settings.admin.table.col.requestedBy": {
    id: "settings.admin.table.col.requestedBy",
    defaultMessage: "Requested by",
  },
  "settings.admin.table.col.paidCredit": {
    id: "settings.admin.table.col.paidCredit",
    defaultMessage: "Credits paid",
  },
  "settings.admin.table.col.remainingCredits": {
    id: "settings.admin.table.col.remainingCredits",
    defaultMessage: "Remaining credits",
  },
  "settings.admin.table.col.requestedCredits": {
    id: "settings.admin.table.col.requestedCredits",
    defaultMessage: "Requested credits",
  },
  "settings.admin.table.col.sumRequestedCredit": {
    id: "settings.admin.table.col.sumRequestedCredit",
    defaultMessage: "All credits",
  },
  "settings.admin.table.col.status": {
    id: "settings.admin.table.col.status",
    defaultMessage: "Status",
  },
  "settings.admin.table.col.allowedCoachRates": {
    id: "settings.admin.table.col.allowedCoachRates",
    defaultMessage: "Coach rate",
  },
  "settings.admin.table.col.action": {
    id: "settings.admin.table.col.action",
    defaultMessage: "Action",
  },
  "settings.admin.table.edit.tooltip": {
    id: "settings.admin.table.edit.tooltip",
    defaultMessage: "Edit",
  },
  "settings.admin.table.confirm-credit-button.label": {
    id: "settings.admin.table.confirm-credit-button.label",
    defaultMessage: "Confirm",
  },

  "settings.admin.member.modal.title": {
    id: "settings.admin.member.modal.title",
    defaultMessage: "Add new member",
  },
  "settings.admin.member.modal.desc": {
    id: "settings.admin.member.modal.desc",
    defaultMessage:
      "To add a new member, enter the required information below.",
  },
  "settings.admin.member.modal.title.edit": {
    id: "settings.admin.member.modal.title.edit",
    defaultMessage: "Edit member",
  },
  "settings.admin.member.modal.desc.edit": {
    id: "settings.admin.member.modal.desc.edit",
    defaultMessage:
      "To add a new member, enter the required information below.",
  },

  "settings.admin.member.modal.fields.firstName": {
    id: "settings.admin.member.modal.fields.firstName",
    defaultMessage: "Name",
  },
  "settings.admin.member.modal.fields.lastName": {
    id: "settings.admin.member.modal.fields.lastName",
    defaultMessage: "Surname",
  },
  "settings.admin.member.modal.fields.username": {
    id: "settings.admin.member.modal.fields.username",
    defaultMessage: "Email",
  },
  "settings.admin.member.modal.fields.companyId": {
    id: "settings.admin.member.modal.fields.companyId",
    defaultMessage: "Company",
  },
  "settings.admin.member.modal.fields.authorities": {
    id: "settings.admin.member.modal.fields.authorities",
    defaultMessage: "Roles",
  },
  "settings.admin.member.modal.fields.coach": {
    id: "settings.admin.member.modal.fields.coach",
    defaultMessage: "Current coach",
  },
  "settings.admin.member.modal.fields.credit": {
    id: "settings.admin.member.modal.fields.credit",
    defaultMessage: "Credit",
  },
  "settings.admin.member.modal.fields.status": {
    id: "settings.admin.member.modal.fields.status",
    defaultMessage: "Status",
  },
  "settings.admin.member.modal.fields.locale": {
    id: "settings.admin.member.modal.fields.locale",
    defaultMessage: "Select languages",
  },
  "settings.admin.member.modal.fields.timeZone": {
    id: "settings.admin.member.modal.fields.timeZone",
    defaultMessage: "Timezone",
  },
  "settings.admin.member.modal.fields.allowedCoachRates": {
    id: "settings.admin.member.modal.fields.allowedCoachRates",
    defaultMessage: "Allowed coach rates",
  },
  "settings.admin.member.modal.fields.rate": {
    id: "settings.admin.member.modal.fields.rate",
    defaultMessage: "Rate",
  },
  "settings.admin.member.modal.fields.certificate": {
    id: "settings.admin.member.modal.fields.certificate",
    defaultMessage: "Certificate",
  },

  "settings.admin.member.trial": {
    id: "settings.admin.member.trial",
    defaultMessage: "Trial user",
  },
  "settings.admin.member.cancel": {
    id: "settings.admin.member.cancel",
    defaultMessage: "Cancel",
  },
  "settings.admin.member.submit.new": {
    id: "settings.admin.member.submit.new",
    defaultMessage: "Send invite",
  },
  "settings.admin.member.submit.edit": {
    id: "settings.admin.member.submit.edit",
    defaultMessage: "Save",
  },
});
